var map = {
	"./Img-01.jpg": 289,
	"./Img-02.jpg": 290,
	"./Img-03.jpg": 291,
	"./Img-05.jpg": 292,
	"./Img-07.jpg": 293,
	"./K.png": 294,
	"./b.png": 295,
	"./blog-grid/author_img.png": 296,
	"./blog-grid/blog_list1.jpg": 297,
	"./blog-grid/blog_list2.jpg": 298,
	"./blog-grid/blog_list3.jpg": 299,
	"./blog-grid/blog_list4.jpg": 300,
	"./blog-grid/blog_single.png": 301,
	"./blog-grid/comment1.png": 302,
	"./blog-grid/comment2.png": 303,
	"./blog-grid/post_1.jpg": 304,
	"./blog-grid/post_2.jpg": 305,
	"./blog-grid/post_3.jpg": 306,
	"./blog-grid/post_4.jpg": 307,
	"./blog-grid/post_img_1.png": 308,
	"./blog-grid/post_img_2.png": 309,
	"./blog-grid/post_img_3.png": 310,
	"./br_logo.png": 311,
	"./breadcrumb/banner_bg.png": 312,
	"./breadcrumb/service.png": 313,
	"./breadcrumb/service_details.png": 314,
	"./breadcrumb/service_details_one.png": 315,
	"./cart1.jpg": 316,
	"./cart2.jpg": 317,
	"./erp-home/action_img.png": 318,
	"./erp-home/background.png": 319,
	"./erp-home/banner_shap.png": 320,
	"./erp-home/cloud-computing.png": 321,
	"./erp-home/cloud_01.png": 322,
	"./erp-home/cloud_02.png": 323,
	"./erp-home/cloud_03.png": 324,
	"./erp-home/cloud_04.png": 325,
	"./erp-home/cloud_05.png": 326,
	"./erp-home/cloud_06.png": 327,
	"./erp-home/crm_img1.jpg": 328,
	"./erp-home/crm_img2.jpg": 329,
	"./erp-home/crm_img3.jpg": 330,
	"./erp-home/erp_dashboard.jpg": 331,
	"./erp-home/erp_icon1.png": 332,
	"./erp-home/erp_icon2.png": 333,
	"./erp-home/erp_icon3.png": 334,
	"./erp-home/erp_icon4.png": 335,
	"./erp-home/erp_icon5.png": 336,
	"./erp-home/erp_icon6.png": 337,
	"./erp-home/growth.png": 338,
	"./erp-home/img/01.png": 339,
	"./erp-home/img/02.png": 340,
	"./erp-home/img/03.png": 341,
	"./erp-home/img/04.png": 342,
	"./erp-home/img/05.png": 343,
	"./erp-home/img/06.png": 344,
	"./erp-home/img/07.png": 345,
	"./erp-home/img/08.png": 346,
	"./erp-home/img/09.png": 347,
	"./erp-home/img/10.png": 348,
	"./erp-home/img/11.png": 349,
	"./erp-home/img/12.png": 350,
	"./erp-home/img/13.png": 351,
	"./erp-home/img/14.png": 352,
	"./erp-home/img/15.png": 353,
	"./erp-home/img/16.png": 354,
	"./erp-home/img/17.png": 355,
	"./erp-home/img/18.png": 356,
	"./erp-home/img/19.png": 357,
	"./erp-home/img/20.png": 358,
	"./erp-home/quote.png": 359,
	"./erp-home/rocket.png": 360,
	"./erp-home/settings1.png": 361,
	"./erp-home/shape.png": 362,
	"./erp-home/testimonial_img.jpg": 363,
	"./erp-home/testimonial_img2.jpg": 364,
	"./error_bg.png": 365,
	"./favicon.png": 366,
	"./home-security/about_img_1.jpg": 367,
	"./home-security/about_img_2.jpg": 368,
	"./home-security/apple_icon.png": 369,
	"./home-security/banner.png": 370,
	"./home-security/leaf_clients1.png": 371,
	"./home-security/leaf_clients2.png": 372,
	"./home-security/mackbook.png": 373,
	"./home-security/padlock.png": 374,
	"./home-security/real-estate.png": 375,
	"./home-security/rocket.png": 376,
	"./home-security/security_1.png": 377,
	"./home-security/security_2.png": 378,
	"./home-security/security_3.png": 379,
	"./home-security/security_4.png": 380,
	"./home-security/shap.png": 381,
	"./home-security/sheld_bg.png": 382,
	"./home-security/shield.png": 383,
	"./home-security/windows_icon.png": 384,
	"./home-software/analytices1.png": 385,
	"./home-software/analytices2.png": 386,
	"./home-software/analytices3.png": 387,
	"./home-software/analytices4.png": 388,
	"./home-software/analytices5.jpg": 389,
	"./home-software/analytices6.jpg": 390,
	"./home-software/analytices7.jpg": 391,
	"./home-software/analytices8.jpg": 392,
	"./home-software/case.png": 393,
	"./home-software/down_bg.png": 394,
	"./home-software/elements_five.png": 395,
	"./home-software/elements_four.png": 396,
	"./home-software/elements_one.png": 397,
	"./home-software/elements_six.png": 398,
	"./home-software/elements_three.png": 399,
	"./home-software/elements_two.png": 400,
	"./home-software/line_02.png": 401,
	"./home-software/logo_01.png": 402,
	"./home-software/logo_02.png": 403,
	"./home-software/logo_03.png": 404,
	"./home-software/logo_04.png": 405,
	"./home-software/logo_05.png": 406,
	"./home-software/logo_06.png": 407,
	"./home-software/logo_07.png": 408,
	"./home-software/logo_08.png": 409,
	"./home-software/logo_09.png": 410,
	"./home-software/logo_10.png": 411,
	"./home-software/logo_11.png": 412,
	"./home-software/logo_12.png": 413,
	"./home-software/mackbook.png": 414,
	"./home-software/pie.png": 415,
	"./home-software/setup_img1.png": 416,
	"./home-software/setup_img2.png": 417,
	"./home-software/setup_img3.png": 418,
	"./home-software/shap_3.png": 419,
	"./home-software/shap_one.png": 420,
	"./home-software/shap_two.png": 421,
	"./home2/action_bg.png": 422,
	"./home2/file.png": 423,
	"./home2/inbox.png": 424,
	"./home2/report.png": 425,
	"./home2/undraw.png": 426,
	"./home3/action_image.png": 102,
	"./home3/dimond.png": 103,
	"./home3/logo_01.png": 104,
	"./home3/logo_01_og.png": 105,
	"./home3/logo_02.png": 106,
	"./home3/logo_02_og.png": 107,
	"./home3/logo_03.png": 108,
	"./home3/logo_03_eagle.png": 109,
	"./home3/logo_03_micropython.png": 110,
	"./home3/logo_03_og.png": 111,
	"./home3/logo_04.png": 112,
	"./home3/logo_04_og.png": 113,
	"./home3/logo_05.png": 114,
	"./home3/logo_05_og.png": 115,
	"./home3/logo_06.png": 116,
	"./home3/logo_07.png": 117,
	"./home3/logo_08.png": 118,
	"./home3/p_feature1.png": 119,
	"./home3/prototype_banner_img.png": 120,
	"./home3/prototype_banner_img2.png": 121,
	"./home3/psd.png": 122,
	"./home3/saas.png": 123,
	"./home3/tab.png": 124,
	"./home4/action_shap.png": 427,
	"./home4/author_img.png": 428,
	"./home4/banner_bg.png": 429,
	"./home4/banner_img.png": 430,
	"./home4/divider.png": 431,
	"./home4/dot.png": 432,
	"./home4/icon01.png": 433,
	"./home4/icon02.png": 434,
	"./home4/icon3.png": 435,
	"./home4/icon_04.png": 436,
	"./home4/icon_05.png": 437,
	"./home4/icon_shape1.png": 438,
	"./home4/icon_shape2.png": 439,
	"./home4/icon_shape3.png": 440,
	"./home4/icon_shape4.png": 441,
	"./home4/process_1.png": 442,
	"./home4/process_2.png": 443,
	"./home4/process_3.png": 444,
	"./home4/process_4.png": 445,
	"./home4/process_5.png": 446,
	"./home4/shape.png": 447,
	"./home4/team1.jpg": 448,
	"./home4/team2.jpg": 449,
	"./home4/work1.png": 450,
	"./home4/work2.png": 451,
	"./home4/work3.png": 452,
	"./home5/01.jpg": 453,
	"./home5/02.jpg": 454,
	"./home5/03.jpg": 455,
	"./home5/banner_img.png": 456,
	"./home5/design1.png": 457,
	"./home5/design2.png": 458,
	"./home5/featured_bg_shape.png": 459,
	"./home5/featured_img1.png": 460,
	"./home5/icon1.png": 461,
	"./home5/icon2.png": 462,
	"./home5/icon3.png": 463,
	"./home5/icon_shape.png": 464,
	"./home5/php.jpg": 465,
	"./home5/shap_tecture.png": 466,
	"./home7/01.png": 467,
	"./home7/02.png": 468,
	"./home7/03.png": 469,
	"./home7/app.png": 470,
	"./home7/banner.png": 471,
	"./home7/google_icon.png": 472,
	"./home7/iPhoneX2.png": 473,
	"./home7/iPhonex.png": 474,
	"./home7/screenshot1.png": 475,
	"./home7/screenshot2.png": 476,
	"./home7/screenshot3.png": 477,
	"./home7/screenshot4.png": 478,
	"./home7/screenshot5.png": 479,
	"./home7/team_01.jpg": 480,
	"./home7/team_02.jpg": 481,
	"./home7/team_03.jpg": 482,
	"./home7/team_04.jpg": 483,
	"./home7/testimonial_author_img.png": 484,
	"./home7/text_one.png": 485,
	"./home7/text_three.png": 486,
	"./home7/text_two.png": 487,
	"./home8/banner_img.png": 488,
	"./home8/dot.png": 489,
	"./home8/fact.png": 490,
	"./home8/service_item_03.png": 491,
	"./home9/featured_img.png": 492,
	"./home9/featured_img_two.png": 493,
	"./home9/flag.png": 494,
	"./home9/footer.png": 495,
	"./home9/icon1.png": 496,
	"./home9/icon2.png": 497,
	"./home9/icon3.png": 498,
	"./home9/icon4.png": 499,
	"./home9/icon5.png": 500,
	"./home9/icon6.png": 501,
	"./home9/icon7.png": 502,
	"./home9/icon8.png": 503,
	"./home9/icon_shape.png": 504,
	"./home9/icon_shape_two.png": 505,
	"./home9/logo1.png": 506,
	"./home9/logo2.png": 507,
	"./home9/logo3.png": 508,
	"./home9/logo4.png": 509,
	"./home9/logo5.png": 510,
	"./home9/logo6.png": 511,
	"./home9/logo7.png": 512,
	"./home9/logo8.png": 513,
	"./home9/mac.png": 514,
	"./home9/map.png": 515,
	"./home9/shape-footer.png": 516,
	"./home9/shape.png": 517,
	"./home9/shape_two.png": 518,
	"./home9/testimonial_img.png": 519,
	"./home9/testimonial_img2.png": 520,
	"./home9/triangle_bottom.png": 521,
	"./home9/triangle_top.png": 522,
	"./hosting/action_img.png": 523,
	"./hosting/business1.png": 524,
	"./hosting/business2.png": 525,
	"./hosting/h_blog1.jpg": 526,
	"./hosting/h_blog2.jpg": 527,
	"./hosting/hosting-image.png": 528,
	"./hosting/hosting_action_bg.png": 529,
	"./hosting/icon1.png": 530,
	"./hosting/icon10.png": 531,
	"./hosting/icon2.png": 532,
	"./hosting/icon3.png": 533,
	"./hosting/icon4.png": 534,
	"./hosting/icon5.png": 535,
	"./hosting/icon6.png": 536,
	"./hosting/icon7.png": 537,
	"./hosting/icon8.png": 538,
	"./hosting/icon9.png": 539,
	"./hosting/line_01.png": 540,
	"./hosting/line_02.png": 541,
	"./hosting/line_03.png": 542,
	"./hosting/line_04.png": 543,
	"./hosting/line_05.png": 544,
	"./hosting/line_06.png": 545,
	"./hosting/line_07.png": 546,
	"./hosting/line_08.png": 547,
	"./hosting/map.png": 548,
	"./hosting/region_map.png": 549,
	"./login_img.png": 550,
	"./login_img2.png": 551,
	"./logo-3-2x.png": 552,
	"./logo-sticky-2x.png": 553,
	"./logo-sticky.png": 554,
	"./logo-sticky2.png": 555,
	"./logo-sticky3.png": 556,
	"./logo-sticky4.png": 557,
	"./logo.png": 55,
	"./logo2.png": 54,
	"./logo2x-2.png": 558,
	"./logo2x.png": 559,
	"./logo3.png": 560,
	"./logo4.png": 561,
	"./logo7.png": 562,
	"./logo8.png": 563,
	"./mega-menu-img/Prototyping_Tool.jpg": 564,
	"./mega-menu-img/analytices.jpg": 565,
	"./mega-menu-img/coming_img.jpg": 566,
	"./mega-menu-img/erp.jpg": 567,
	"./mega-menu-img/home-animation.jpg": 568,
	"./mega-menu-img/home-chat.jpg": 569,
	"./mega-menu-img/home-event.jpg": 570,
	"./mega-menu-img/home-security.jpg": 571,
	"./mega-menu-img/home-track.jpg": 572,
	"./mega-menu-img/home1.jpg": 573,
	"./mega-menu-img/home10.jpg": 574,
	"./mega-menu-img/home11.jpg": 575,
	"./mega-menu-img/home12.jpg": 576,
	"./mega-menu-img/home13.jpg": 577,
	"./mega-menu-img/home14.jpg": 578,
	"./mega-menu-img/home15.jpg": 579,
	"./mega-menu-img/home16.jpg": 580,
	"./mega-menu-img/home17.jpg": 581,
	"./mega-menu-img/home2.jpg": 582,
	"./mega-menu-img/home3.jpg": 583,
	"./mega-menu-img/home4.jpg": 584,
	"./mega-menu-img/home5.jpg": 585,
	"./mega-menu-img/home6.jpg": 586,
	"./mega-menu-img/home7.jpg": 587,
	"./mega-menu-img/home8.jpg": 588,
	"./mega-menu-img/home9.jpg": 589,
	"./mega-menu-img/hosting.jpg": 590,
	"./mega-menu-img/icon/app-d.png": 591,
	"./mega-menu-img/icon/blup.png": 592,
	"./mega-menu-img/pos.jpg": 593,
	"./mega-menu-img/saas2-slider.png": 594,
	"./mega-menu-img/support.jpg": 595,
	"./new-home/back_bg.png": 125,
	"./new-home/banner.png": 57,
	"./new-home/banner_low_quality.png": 126,
	"./new-home/banner_og.png": 127,
	"./new-home/briteverify.png": 128,
	"./new-home/briteverify__.png": 129,
	"./new-home/briteverify_____.png": 130,
	"./new-home/briteverify_og.png": 131,
	"./new-home/campfire.png": 132,
	"./new-home/email.png": 58,
	"./new-home/email_og.png": 133,
	"./new-home/kissmetrics.png": 134,
	"./new-home/metorik.png": 135,
	"./new-home/nicereply-1.png": 136,
	"./new-home/nicereply-1__.png": 137,
	"./new-home/nicereply-1_og.png": 138,
	"./new-home/nicereply_.png": 139,
	"./new-home/p-1.png": 140,
	"./new-home/p-2.png": 141,
	"./new-home/p-3.png": 142,
	"./new-home/tab.png": 59,
	"./new-home/tab_2.png": 60,
	"./new-home/tab_2_og.png": 143,
	"./new-home/tab_3.png": 61,
	"./new-home/tab_3_og.png": 144,
	"./new-home/tab_og.png": 145,
	"./new-home/ticket-support.png": 62,
	"./new-home/ticket-support_og.png": 146,
	"./new-home/tree-left.png": 35,
	"./new-home/tree-right.png": 36,
	"./new-home/tree.png": 63,
	"./new-home/update.png": 147,
	"./new-home/webhooks.png": 148,
	"./new-home/webhooks_og.png": 149,
	"./new-home/wedsite.png": 150,
	"./new/01.png": 596,
	"./new/0111.png": 597,
	"./new/02.png": 598,
	"./new/0222.png": 599,
	"./new/03.png": 600,
	"./new/04.png": 601,
	"./new/05.png": 602,
	"./new/06.png": 603,
	"./new/app_screen.png": 604,
	"./new/blog/blog_grid_1.jpg": 605,
	"./new/blog/blog_grid_2.jpg": 606,
	"./new/blog/blog_grid_3.jpg": 607,
	"./new/blog/blog_grid_4.jpg": 608,
	"./new/blog/blog_grid_5.jpg": 609,
	"./new/blog/blog_grid_6.jpg": 610,
	"./new/blog/blog_grid_7.jpg": 611,
	"./new/blog/blog_grid_8.jpg": 612,
	"./new/case/case_01.jpg": 613,
	"./new/case/case_02.jpg": 614,
	"./new/case/case_03.jpg": 615,
	"./new/case/case_04.jpg": 616,
	"./new/case/case_05.jpg": 617,
	"./new/case/case_06.jpg": 618,
	"./new/case/case_07.jpg": 619,
	"./new/case/case_08.jpg": 620,
	"./new/case/case_09.jpg": 621,
	"./new/case/case_10.jpg": 622,
	"./new/case/case_11.jpg": 623,
	"./new/case/case_12.jpg": 624,
	"./new/case/case_details_01.jpg": 625,
	"./new/case/case_details_02.jpg": 626,
	"./new/case/case_details_03.jpg": 627,
	"./new/case/parallax.png": 628,
	"./new/coming_soon_bg.png": 629,
	"./new/company.jpg": 630,
	"./new/cup.png": 631,
	"./new/digital_img.png": 632,
	"./new/error.png": 633,
	"./new/features_01.png": 634,
	"./new/feedback_shap.png": 635,
	"./new/home-split/contact.png": 636,
	"./new/iPhoneX.png": 637,
	"./new/icon.png": 638,
	"./new/icon/icon1.png": 639,
	"./new/icon/icon2.png": 640,
	"./new/icon2.png": 641,
	"./new/icon3.png": 642,
	"./new/intregration_1.png": 643,
	"./new/intregration_2.png": 644,
	"./new/intregration_3.png": 645,
	"./new/intregration_4.png": 646,
	"./new/laptop.png": 647,
	"./new/laptop_two.png": 648,
	"./new/leaf.png": 649,
	"./new/line_01.png": 650,
	"./new/line_02.png": 651,
	"./new/line_03.png": 652,
	"./new/logo_01.png": 653,
	"./new/logo_02.png": 654,
	"./new/logo_03.png": 655,
	"./new/logo_04.png": 656,
	"./new/logo_05.png": 657,
	"./new/member_01.jpg": 658,
	"./new/new_shape.png": 659,
	"./new/phone.png": 660,
	"./new/price_bg.png": 661,
	"./new/shape_bg.png": 662,
	"./new/solution_01.jpg": 663,
	"./new/solution_02.jpg": 664,
	"./new/startup_banner_bg.png": 665,
	"./new/startup_banner_img.png": 666,
	"./new/startup_shap.png": 667,
	"./new/tab_shape_bg.png": 668,
	"./new/testimonial_bg.png": 669,
	"./new/testimonial_bg_shap.png": 670,
	"./new/testimonial_bg_two.png": 671,
	"./new/video_bg.jpg": 672,
	"./new/video_img_01.png": 673,
	"./new/video_img_02.jpg": 674,
	"./new/web_image.jpg": 675,
	"./new_logo.png": 676,
	"./portfolio-details/pr_details1.jpg": 677,
	"./portfolio-details/pr_details2.jpg": 678,
	"./portfolio-details/pr_details3.jpg": 679,
	"./portfolio-details/pr_details4.jpg": 680,
	"./portfolio/2-columns/grid1.jpg": 681,
	"./portfolio/2-columns/grid2.jpg": 682,
	"./portfolio/2-columns/grid3.jpg": 683,
	"./portfolio/2-columns/grid4.jpg": 684,
	"./portfolio/2-columns/grid5.jpg": 685,
	"./portfolio/2-columns/grid6.jpg": 686,
	"./portfolio/2-columns/grid7.jpg": 687,
	"./portfolio/2-columns/grid8.jpg": 688,
	"./portfolio/3-columns/3_col_1.jpg": 689,
	"./portfolio/3-columns/3_col_10.jpg": 690,
	"./portfolio/3-columns/3_col_11.jpg": 691,
	"./portfolio/3-columns/3_col_12.jpg": 692,
	"./portfolio/3-columns/3_col_2.jpg": 693,
	"./portfolio/3-columns/3_col_3.jpg": 694,
	"./portfolio/3-columns/3_col_4.jpg": 695,
	"./portfolio/3-columns/3_col_5.jpg": 696,
	"./portfolio/3-columns/3_col_6.jpg": 697,
	"./portfolio/3-columns/3_col_7.jpg": 698,
	"./portfolio/3-columns/3_col_8.jpg": 699,
	"./portfolio/3-columns/3_col_9.jpg": 700,
	"./portfolio/full-width/full_1.jpg": 701,
	"./portfolio/full-width/full_10.jpg": 702,
	"./portfolio/full-width/full_11.jpg": 703,
	"./portfolio/full-width/full_12.jpg": 704,
	"./portfolio/full-width/full_2.jpg": 705,
	"./portfolio/full-width/full_3.jpg": 706,
	"./portfolio/full-width/full_4.jpg": 707,
	"./portfolio/full-width/full_5.jpg": 708,
	"./portfolio/full-width/full_6.jpg": 709,
	"./portfolio/full-width/full_7.jpg": 710,
	"./portfolio/full-width/full_8.jpg": 711,
	"./portfolio/full-width/full_9.jpg": 712,
	"./pos/High-end-all-in-one-dual-screen.png": 713,
	"./pos/b_dashboard.png": 714,
	"./pos/cash-register.png": 715,
	"./pos/chat.png": 716,
	"./pos/credit-card.png": 717,
	"./pos/delivery-truck.png": 718,
	"./pos/ezgif-1-997e5035cba4.png": 719,
	"./pos/fotter_shap.png": 720,
	"./pos/icon1.png": 721,
	"./pos/icon2.png": 722,
	"./pos/icon3.png": 723,
	"./pos/item1.png": 724,
	"./pos/item2.png": 725,
	"./pos/item3.png": 726,
	"./pos/laptop.png": 727,
	"./pos/leaf-left.png": 151,
	"./pos/leaf-right.png": 152,
	"./pos/mailbox.png": 728,
	"./pos/man.png": 153,
	"./pos/pattern_01.png": 729,
	"./pos/pattern_02.png": 730,
	"./pos/people.png": 154,
	"./pos/pos.png": 731,
	"./pos/pos_about_img.png": 732,
	"./pos/pos_blog_1.png": 733,
	"./pos/pos_blog_2.png": 734,
	"./pos/pos_blog_3.png": 735,
	"./pos/pos_slideshow1.jpg": 736,
	"./pos/pos_slideshow2.jpg": 737,
	"./pos/pos_slideshow3.jpg": 738,
	"./pos/shape.png": 739,
	"./pos/shape_bg.png": 740,
	"./pos/statistics.png": 741,
	"./pos/tab_pattern.png": 742,
	"./pos/wave_two.png": 743,
	"./pos/women.png": 155,
	"./price/one.png": 744,
	"./price/three.png": 745,
	"./price/two.png": 746,
	"./process/ASAN-logo-icon.png": 747,
	"./process/Avast_Antivirus.png": 748,
	"./process/UTorrent_(logo).png": 749,
	"./process/btFMmsoh.png": 750,
	"./process/logo-slack.png": 751,
	"./process/png-logo-design.png": 752,
	"./qoute.png": 753,
	"./saas/map.png": 754,
	"./seo/bike.png": 755,
	"./seo/car.png": 756,
	"./seo/cloud.png": 757,
	"./seo/cloud_bg.png": 758,
	"./seo/features_img.png": 759,
	"./seo/features_img_two.png": 760,
	"./seo/footer_bg.png": 761,
	"./seo/icon1.png": 762,
	"./seo/icon2.png": 763,
	"./seo/icon3.png": 764,
	"./seo/icon4.png": 765,
	"./seo/icon5.png": 766,
	"./seo/image.png": 767,
	"./seo/logo_01.png": 768,
	"./seo/logo_02.png": 769,
	"./seo/logo_03.png": 770,
	"./seo/logo_04.png": 771,
	"./seo/logo_05.png": 772,
	"./seo/logo_06.png": 773,
	"./seo/logo_07.png": 774,
	"./seo/logo_08.png": 775,
	"./seo/logo_09.png": 776,
	"./seo/shap.png": 777,
	"./seo/studies_img_one.jpg": 778,
	"./seo/studies_img_three.jpg": 779,
	"./seo/studies_img_two.jpg": 780,
	"./seo/triangle_one.png": 781,
	"./seo/triangle_three.png": 782,
	"./seo/triangle_two.png": 783,
	"./svg.svg": 784,
	"./teams/team_01.jpg": 785,
	"./teams/team_02.jpg": 786,
	"./teams/team_03.jpg": 787,
	"./teams/team_04.jpg": 788,
	"./teams/team_10.jpg": 789,
	"./teams/team_12.jpg": 790,
	"./teams/team_5.jpg": 791,
	"./teams/team_6.jpg": 792,
	"./teams/team_7.jpg": 793,
	"./teams/team_8.jpg": 794,
	"./teams/team_9.jpg": 795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;